import {API} from 'api';

const uploadImageToUGCBucket = async (file: File) => {
  const response = await API.postFile('/v1/images', 'img', file);
  return `${process.env.NEXT_PUBLIC_UGC_IMAGE_BUCKET}${response.img_url}`;
};

const uploadImageToCMSBucket = async (file: File) => {
  const response = await API.postFile('/v1/cms-images', 'img', file);
  return `${process.env.NEXT_PUBLIC_CMS_IMAGES_BUCKET}${response.img_url}`;
};

const uploadImageToCoursesBucket = async (file: File) => {
  const response = await API.postFile('/v1/courses-images', 'img', file);
  return (response.img_url as string).replace('/learning_paths/', '');
};

const uploadProfileImage = async (file: File) => {
  const response = await API.postFile('/v1/profile-image', 'img', file);
  return `${process.env.NEXT_PUBLIC_PROFILE_IMAGE_BUCKET}${response.img_url}`;
};

const uploadUserNoteBook = async (file: File) => {
  const response = await API.postFile('/v1/user-submission-notebook', 'ipynb', file);
  return response.notebook_url as string;
};

export const UploadsAPI = {
  uploadImageToUGCBucket,
  uploadImageToCMSBucket,
  uploadProfileImage,
  uploadImageToCoursesBucket,
  uploadUserNoteBook,
};
